// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-673099cc] {\n  padding-left: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
